export default __webpack_public_path__ + "static/media/Img125.c05513cd.jpg";